import {Event} from 'main.core';

export class BuyBlock extends Event.EventEmitter {
    constructor(params = {}) {
        super();
        this.setEventNamespace('BX.Asteq.Catalog.BuyBlock');

        this.el = document.querySelector('#' + params.componentId);
        if (!this.el) {
            console.error('Не удалось найти блок #' + params.componentId);
        }

        this.currentOffer = params.currentOffer;
        this.prevOffer = params.currentOffer;
        this.product = params.product;
        this.buyBlock = this.el.querySelector('[data-can-buy-block="true"]');
        this.noBuyBlock = this.el.querySelector('[data-can-buy-block="false"]');
        this.countInput = this.el.querySelector('[data-count]');
        this.buyButtonEl = this.el.querySelector('[data-buy-button]');

        this.fastViewButton = this.el.querySelector('[data-fastview]');
        if (this.fastViewButton) {
            this.fastViewButton.addEventListener('click', this.onFastViewClick.bind(this));
        }

        this.initCountUpdater();
    }

    initCountUpdater() {
        if (!this.countInput || !this.buyButtonEl) {
            return;
        }

        this.countInput.addEventListener('input', (e) => {
            this.buyButtonEl.dataset.count = e.target.value;
        });
    }

    updateData() {
        this.el.querySelectorAll('[data-id]')
            .forEach((el) => el.dataset.id = this.currentOffer.id);

        const addUrlTemplate = this.product?.addUrlTemplate;
        if (addUrlTemplate) {
            this.el.querySelectorAll('[data-url]')
                .forEach((el) => el.dataset.url = addUrlTemplate.replace('#ID#', this.currentOffer.id));
        }


        if (this.prevOffer && this.currentOffer) {
            this.el.querySelectorAll('.js-count-' + this.prevOffer.id)
                .forEach((el) => el.classList.replace(
                    'js-count-' + this.prevOffer.id,
                    'js-count-' + this.currentOffer.id));
        }

        this.el.querySelectorAll('[data-price]')
            .forEach((el) => el.innerHTML = this.currentOffer.price.format);

        this.el.querySelectorAll('[data-link-detail]')
            .forEach((el) => {
                el.setAttribute('href', this.currentOffer.url);
            });

        if (this.product?.productId) {
            document.querySelectorAll(`[data-article="${this.product.productId}"]`)
                .forEach((el) => {
                    el.innerHTML = this.currentOffer.article ?? '&nbsp;';
                });
        }
    }

    showBuyBlock() {
        if (!this.currentOffer) {
            return;
        }

        if (this.noBuyBlock) {
            this.noBuyBlock.style.display = 'none';
        }

        if (this.buyBlock) {
            this.buyBlock.style.display = null;
        }
    }

    hideBuyBlock() {
        if (this.noBuyBlock) {
            this.noBuyBlock.style.display = null;
        }

        if (this.buyBlock) {
            this.buyBlock.style.display = 'none';
        }
    }

    updateBlock() {
        if (this.currentOffer && this.currentOffer.canBuy) {
            this.showBuyBlock();
        } else {
            this.hideBuyBlock();
        }
    }

    onOfferChange(e) {
        const eventData = e.getData();
        this.prevOffer = eventData.oldOffer;
        this.currentOffer = eventData.newOffer;
        this.updateData();
        this.updateBlock();
        this.actualizeBusketButton(eventData.newOffer.id);
    }

    onFastViewClick(e) {
        this.emit('fastViewClick');
    }

    actualizeBusketButton(id) {
        let button = $('.js-add-to-basket[data-id="' + id + '"]');
        let buttonContainer = button.closest('div[id*="js-offer-buy-"]');
        if (buttonContainer.length > 0) {
            let a = buttonContainer.find('.js-link-to-basket');
            let productId = button[0].dataset.id;
            let counter = $(buttonContainer).find('.counter');
            $.ajax({
                url: '/local/ajax/get_basket.php',
                method: 'get',
                dataType: 'json',
                success: function (data) {
                    if (data[productId]) {
                        button.hide();
                        counter.hide();
                        a.show();
                    } else {
                        button.show();
                        counter.show();
                        a.hide();
                    }
                }
            });
        }
    }
}